export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#4C85AF',
    light: '#F4F9FF'
  },
  secondary: {
    main: '#F0894C',
    contrastText: '#0A5285',
    light: '#D9EDF7'
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#6CA4CD',
    paper: '#FFF',
    default: '#FFF',
    header: '#EEF6FA',
    footer: '#F4F9FF',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#004A87',
    tableSubhead: '#EEF6FA',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#343538',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#E75204',
    secondary: '#F8D859',
    light: '#F4F9FF',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb'
  },
  verticalBar: {
    used: '#4C85AF',
    unused: '#F4F9FF',
    unlimited: '#C0C0C0',
  }
};
